module.exports = __webpack_public_path__ + "img/detail_print@2x.f7710177.png";